import React from 'react';

export default function Dashboard(props) {

  console.log('in dboard', props)
  var myUserLandscape = props.userLandscape;
  var myUserInfo = props.userLandscape.user;
  var myThings = props.userLandscape.allthings;
  var myThingsByGroup = props.userLandscape.things_by_group


  //myThings = new Map([...myThings.entries()].sort());
  var mySwitches = props.userLandscape.switches;
  var myPolicyPrincipals = props.userLandscape.principles;

  function handleChange(e) {
    console.log('handlechange');
    console.log(e.target);
  }

  function handleDelete(e) {
    console.log('handlechange');
    console.log(e.target);
  }

return (
  <>
<br/>
<h4>CUSTOMER:{myUserInfo.user_customer_id.S} <br/>
user_email:{myUserInfo.user_email.S} <br/>
cognito_username:{myUserInfo.user_id.S} <br/>
cognito_identity:{myUserInfo.user_cognito_id.S} <br/>
</h4>

<h1 align="center">{props.userLandscape.customer.customer_name.S}'s Switches</h1>
  <div style={{ padding: 20 }}>
  <table border="5" align="center"><thead><tr><th>Index</th><th>Customer ID</th><th>SwitchID</th></tr></thead><tbody>
          {mySwitches?.map((a_switch, index) => (
              <tr id={a_switch.customer_id.S} >
                <td>{index+1}</td>
                <td>{a_switch.customer_id.S}</td>
                 <td>{a_switch.switch_id.S}</td>          
          </tr>
          ))}
          </tbody></table>
    </div>

  <h1 align="center">Things by Group</h1>
  <div style={{ padding: 20 }}>
  <table border="5" align="center"><thead><tr><th>Index</th><th>Thing Name</th></tr></thead><tbody>
          {myThingsByGroup?.map((a_switch, index) => (
              <tr id={a_switch} key={a_switch}>
                <td>{index+1}</td>
                <td>{a_switch}</td>
          </tr>
          ))}
          </tbody></table>
    </div>

    <h1 align="center">Things All</h1>
  <div style={{ padding: 20 }}>
  <table border="5" align="center"><thead><tr><th>Index</th><th>Thing Name</th><th>Serial Number</th><th>Hide</th><th>Delete</th></tr></thead><tbody>
          {myThings?.map((a_switch, index) => (
              <tr id={a_switch.attributes.serialNumber} key={a_switch.attributes.serialNumber}>
                <td>{index+1}</td>
                <td>{a_switch.thingName}</td>
                <td>{a_switch.attributes.serialNumber}</td>
                <td><input type="checkbox" value={a_switch.attributes.serialNumber} id={a_switch.attributes.serialNumber} onChange={handleChange} /></td>
                <td><button type="button" value={a_switch.attributes.serialNumber} id={a_switch.attributes.serialNumber} onChange={handleDelete}>Delete Me</button></td>
          </tr>
          ))}
          </tbody></table>
    </div>

  <h1>PRINCIPALS attached to the policy</h1>
  <div style={{ padding: 20 }}>
  <table border="5" align="center"><thead><tr><th>Index</th><th>Principals-Attached-to-Policy</th></tr></thead><tbody>
          {myPolicyPrincipals?.map((a_switch, index) => (
              <tr key={a_switch} >
                <td>{index+1}</td>
                <td>{a_switch}</td>
                       
          </tr>
          ))}
          </tbody></table>
    </div>

    

    </>
)
}
